import React from 'react';
import { Editor, Node, Text } from 'slate';
import { ReactEditor, useSlateStatic } from 'slate-react';
import application from 'application';
import * as serializer from 'basic-editor-value-serializer';
import { fillRegion } from '../../helpers/utilities/site-nav/fill';

const LABELS = {
  brand: 'Add brand name',
  'navigation-start': 'Add link',
  'navigation-end': 'Add link',
  submenu: 'Add link',
  actions: 'Add button',
  utility: 'Add utility text'
};

function isBlankParagraph(node) {
  return node.type === 'paragraph' && node.children.every(Text.isText) && Node.string(node) === '';
}

// A region whose text was cleared keeps an empty paragraph; it counts as empty too.
function isEmpty(element) {
  if (element.children.length !== 1) {
    return false;
  }
  return element.children[0].text === '' || isBlankParagraph(element.children[0]);
}

// Joined link groups need one prompt; brand-centered shows each group on its own side.
function isShown(editor, element, path) {
  const role = element.properties.role;
  if (role === 'navigation') {
    return false;
  }
  if (role !== 'navigation-start' && role !== 'navigation-end') {
    return true;
  }
  const header = Editor.above(editor, { at: path, match(node) { return node.type === 'site-nav'; } });
  if (serializer.utilities.node.siteNav.readSettings(header[0]).arrangement === 'brand-centered') {
    return true;
  }
  return role === 'navigation-start' && isEmpty(Node.parent(editor, path).children[1]);
}

function preventFocusLoss(event) {
  event.preventDefault();
}

// Editor-only prompt in an empty header region; published pages give empty regions no space.
function Placeholder(props) {
  const editor = useSlateStatic();
  if (!isEmpty(props.element)) {
    return null;
  }
  const path = ReactEditor.findPath(editor, props.element);
  if (!isShown(editor, props.element, path)) {
    return null;
  }
  const role = props.element.properties.role;
  function fill() {
    fillRegion(editor, ReactEditor.findPath(editor, props.element), role, { brandName: application.startupModule.data.name });
    ReactEditor.focus(editor);
  }
  return <button type="button" className="site-nav-placeholder" contentEditable={false} onMouseDown={preventFocusLoss} onClick={fill}>{LABELS[role]}</button>;
}

export default Placeholder;
